import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box, Button, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'

import AppToolbar from '../../AppBar/AppToolbar'

const classes = {
    root: {
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: (theme) => `1px ${theme.palette.grey[300]} solid`,
        width: '100%',
        height: 'calc(100vh - 154px)',
        gap: 3,
    },
    sorryImage: {
        width: '700px',
    },
    sorryMessage: {
        gap: 1,
    },
}

const ErrorPageContainer = ({ linkHref, linkText, subtitle, title }) => {
    const { t } = useTranslation()

    return (
        <>
            <AppToolbar />
            <Grid
                component="section"
                size={12}
                container
            >
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 12,
                        },
                        classes.root,
                    ]}
                >
                    <Box
                        alt="Sorry"
                        component="img"
                        src="sorry.svg"
                        sx={classes.sorryImage}
                    />

                    <Box
                        sx={[
                            {
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            },
                            classes.sorryMessage,
                        ]}
                    >
                        <Typography variant="h4">{t(title)}</Typography>
                        <Typography variant="body2">{t(subtitle)}</Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => {
                            window.location.href = linkHref
                        }}
                    >
                        {t(linkText)}
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

ErrorPageContainer.propTypes = {
    linkHref: PropTypes.string,
    linkText: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
}

export default ErrorPageContainer
